export const MenuSearch = () => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.29297 9.99984H4.3763M2.29297 5.62484H5.20964M2.29297 14.3748H5.20964M16.2513 13.7498L18.543 16.0415M17.7096 9.99984C17.7096 12.8763 15.3778 15.2082 12.5013 15.2082C9.62482 15.2082 7.29297 12.8763 7.29297 9.99984C7.29297 7.12335 9.62482 4.7915 12.5013 4.7915C15.3778 4.7915 17.7096 7.12335 17.7096 9.99984Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default MenuSearch
